<template>
  <div class="codefill-con">
    <div class="review-type-tab" v-if="$route.query.mode === 'review'">
      <p></p>
      <span :class="{ on: _reviewType === 1 }" @click="_reviewType = 1">我的答案</span>
      <span :class="{ on: _reviewType === 2 }" @click="_reviewType = 2">正确答案</span>
    </div>
    <div class="supplement answer-content">
      <div class="des" v-html="des"></div>
      <div class="supplement-content">
        <div class="supplement-content-tabs">
          <p :class="{ active: codeTabIndex === index }" v-for="(item, index) in newOptions" :key="index" @click="codeTabIndex = index">
            {{ item.name }}.{{ item.suffix }}
            <span></span>
          </p>
        </div>
        <div class="supplement-content-code">
          <pre v-for="(item, index) in newOptions" :key="index" v-show="codeTabIndex === index" v-html="item.code"></pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    des: {
      type: String,
      default: ''
    },
    answer: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 1-我的答案，2-正确答案
    reviewType: {
      type: Number,
      default: 1
    },
    // 题目index
    index_: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      codeTabIndex: 0, // 当前代码块的下标
      replaceStr: '乄', // 替换的字符正则表达式，将这个字符换成输入框
      newOptions: [], // 代码块的dom
      parseResObj: null, // 编译结果
      isInput: false // 学生是否输入过数据
    }
  },
  created() {
    this.renderDom()
  },
  computed: {
    // 回顾试卷类型
    _reviewType: {
      get() {
        return this.reviewType
      },
      set(val) {
        this.$emit('update:reviewType', val)
      }
    },
    // 是否是回顾试卷
    isReview() {
      return this.$route.query.mode === 'review'
    },
    editorConfig() {
      const obj = this.isReview ? { otherOptions: { readOnly: true } } : {}
      return obj
    }
  },

  mounted() {
    this.$nextTick(() => {
      window[`changeCode${this.index_}`] = this.changeCode
      // 修改a标签的数据
      const domA = document.querySelectorAll('.supplement .des a')
      domA.forEach(item => {
        if (item.getAttribute('href').indexOf('http') !== 0) {
          item.setAttribute('href', '/' + item.getAttribute('href'))
        }
        console.log(item.getAttribute('href'))
      })
      // 修改img标签的数据
      const domImg = document.querySelectorAll('.supplement .des img')
      domImg.forEach(item => {
        if (item.getAttribute('src').indexOf('http') !== 0) {
          item.setAttribute('src', '/' + item.getAttribute('src'))
        }
      })
    })
  },
  methods: {
    handleCompile() {
      this.$refs.MonacoEditor.handleParser()
    },
    // 代码验证结果
    parseRes(obj) {
      this.parseResObj = obj
    },
    // 输入框有改动的时候
    changeCode(event) {
      // 如果是回顾试题就忽略
      if (this.isReview) return false
      // 获取当前填空题下所有输入框并获得输入的值
      const inputArr = event.parentNode.parentNode.querySelectorAll('.input-fill')
      const data = Array.from(inputArr).map(item => {
        return item.value.trim()
      })
      // 设置为学生输入过
      this.isInput = true
      this.$emit('update:answer', JSON.stringify(data))
    },
    // 渲染dom
    renderDom() {
      console.log('rander')
      let newAnswer = []
      if (this.answer) {
        newAnswer = JSON.parse(this.answer)
        // 如果是回顾试题的正确答案或者是综合题型，需要再格式化下answer
        if (this.isReview && this._reviewType === 2) {
          // 先转成二位数组
          let arr = newAnswer.map(item => {
            return item.split(this.replaceStr)
          })
          // 再平铺成一维数组
          newAnswer = [].concat(...arr)
        }
      }
      let index_ = 0 // 记录当前的输入框个数
      this.newOptions = this.options.map(item => {
        let strArr = item.code.split(this.replaceStr)
        strArr = strArr.map((item, index) => {
          let str = item
          if (index > 0) {
            if(newAnswer && newAnswer.length > 0) {
              newAnswer[index_] = newAnswer[index_].includes('"') ? newAnswer[index_].replaceAll('"', '&quot;') : newAnswer[index_]
            }
            str =
              `<input class="input-fill" oninput="changeCode${this.index_}(this)" value="${newAnswer[index_]}" ${
                this.isReview ? 'disabled' : ''
              } style="border-radius: 2px; border: none;width: 100px;padding: 0 6px;outline: none; margin: 3px 3px 3px 0; ${
                this.isReview ? 'background: #aaa;' : ''
              }" />` + item
            index_++
          }
          return str
        })
        return {
          ...item,
          code: strArr.join('')
        }
      })
    }
  },
  watch: {
    answer(newVal, oldVal) {
      // 如果还没有渲染代码或者answer从无到有的改变就执行renderDom
      if (this.newOptions.length === 0 || (!oldVal && newVal && !this.isInput) || this.isReview) this.renderDom()
    }
  }
}
</script>

<style lang="scss" scoped>
.supplement {
  display: flex;
  height: 560px !important;
  // height: 100%;
  // min-height: 300px;
  .des {
    width: 30%;
    height: 100%;
    background-color: #343d45;
    color: #fff;
    padding: 10px 20px;
    overflow-y: auto;
    border-right: 1px solid #1e1e1e;
    line-height: 20px;
  }
  &-content {
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;
    &-note {
      height: 100px;
      background-color: #343d45;
      padding: 10px;
      color: #fff;
      line-height: 25px;
      overflow-y: auto;
      font-size: 13px;
    }
    &-code {
      height: calc(100% - 40px);
      background-color: #282c34;
      padding: 15px;
      box-sizing: border-box;
      pre {
        color: #d5d9e0;
        height: 100%;
        box-sizing: border-box;
        overflow: auto;
        line-height: 26px;
      }
    }
    &-tabs {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background-color: #343d45;
      display: flex;
      justify-content: flex-start;
      & > p {
        padding: 0 30px;
        color: #999999;
        cursor: pointer;
        font-size: 16px;
        position: relative;
        &:hover {
          background: rgba(0, 0, 0, 0.3);
        }
        span {
          display: none;
          width: 30px;
          height: 2px;
          background: #d8d8d8;
          position: absolute;
          left: 50%;
          margin-left: -15px;
          bottom: 0;
        }
        &.active {
          span {
            display: block;
          }
          color: #ffffff;
        }
      }
    }
  }
}
</style>
